export default __webpack_public_path__ + "static/media/plus_small_grey.cda780ad.svg";